import {Component} from '@angular/core';
import {EditCustomerPrimaryAccountComponent} from '../edit-customer-primary-account/edit-customer-primary-account.component';

@Component({
    selector: 'app-edit-customer-legacy-primary-account',
    templateUrl: './edit-customer-legacy-primary-account.component.html',
    standalone: false
})
export class EditCustomerLegacyPrimaryAccountComponent extends EditCustomerPrimaryAccountComponent {
}
